import * as React from 'react';
import styled from 'styled-components';

import * as Icon from '../../icons';
import { splitClasses } from '../utils';
import { useGetter, slot, useEffect } from './slots';
import { ctxSelectClass } from './shared';
import { reset } from './Cursor';


const Component = slot('indicator')(({ className }) => {

    const service =            useGetter('service');
    const dropdownController = useGetter('dropdown');
    const targetController =   useGetter('target');
    const dropdownTarget =     useGetter('dropdownTarget');

    const cursorController =   useGetter('cursor');
    const [dropdownOpened] =   useEffect('dropdownOpened');
    const [dropdownClosed] =   useEffect('dropdownClosed');
    const [changeTarget] =     useEffect('changeTarget');
    const [changeValue] =      useEffect('changeValue');


    const resetData = () => {
        const x = dropdownTarget.getData();
        dropdownTarget.changeData(x);
    };

    const variants = {
        default: {
            icon: (
                <IconWrapper>
                    <SelectIcon />
                </IconWrapper>
            ),
            handler: () => {
                dropdownController.open();
                targetController.active();
            },
        },
        openedEmpty: {
            icon: (
                <IconWrapper style={{ transform: 'rotate(90deg)' }}>
                    <SelectIcon />
                </IconWrapper>
            ),
            handler: () => {
                dropdownController.close();
            },
        },
        opened: {
            icon: (
                <CloseWrapper>
                    <Close>
                        <CloseIcon />
                    </Close>
                </CloseWrapper>
            ),
            handler: () => {
                targetController.reset();
                targetController.active();
                service.onClear(service.name);
                resetData();
                cursorController.set(reset());
            },
        }
    }

    const { icon, handler } = React.useMemo(() => {
        const targetIsEmpty = targetController.isEmpty();
        const dropdownIsOpen = dropdownController.isOpen();
        
        if(dropdownIsOpen && targetIsEmpty){
            return variants.openedEmpty;
        }
        else if(dropdownIsOpen && !targetIsEmpty){
            return variants.opened;
        }
        else {
            return variants.default;
        }
    }, [dropdownOpened, changeTarget, dropdownClosed, changeValue]);

    return (
        <SelectButton 
            className={splitClasses(ctxSelectClass('indicator'), className)}
            onMouseDown={handler}>
            {icon}
        </SelectButton>
    );
});

export default Component;

export const SelectButton = styled.button`
    position: relative;
    background: transparent;
    line-height: 0;
    /* padding: .5em 1em; */
    transition: all .33s ease;
    transform-origin: 50% 50%;
    width: 34px;
`;


const IconWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CloseWrapper = styled.div`
`;

export const Close = styled.button`
    background-color: #9C99B8;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    line-height: 0;
    position: relative;
    border: 0;

    &:hover {
        background-color: #7F7B9B;
    }

    & > svg {
        fill: #fbfbfd;
        position: absolute;
        top: 50%;
        left: 50%;
        width: calc(100% - 8px);
        height: calc(100% - 8px);
        transform: translate(-50%, -50%);
    }
`;

const CloseIcon = styled(Icon.Close)`
    width: 6px;
    height: 6px;
    margin: auto;
`;

const SelectIcon = styled(Icon.Select)`
    width: 7px;
    height: 9px;
    margin: auto;
`;
